var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@feb-team/legao-icons-react';
import { defaultProps } from './defaults';
import { DivTag, SpanTag } from '../../Utils/AtomicTag';
import { inputDateParseDate } from './utils';
import { formatDate, parseDate, formatTime, getNextMonth, getNextYear, getPrevMonth, getPrevYear, } from '@feb-team/data-logic';
import { DateYearPicker } from './DateYearPicker';
import { DateMonthPicker } from './DateMonthPicker';
import { DateDayPicker } from './DateDayPicker';
import TimeComboBox from '../TimePicker/Combobox';
var Calendar = /** @class */ (function (_super) {
    __extends(Calendar, _super);
    function Calendar(props) {
        var _this = _super.call(this, props) || this;
        _this.datePattern = 'yyyy-MM-dd';
        _this.timePattern = 'HH:mm:ss';
        /**
         * 格式化数据
         * @param defaultValue
         * @param defaultRangeValues
         */
        _this.getParseDate = function (defaultValue, defaultRangeValue) {
            var _a = _this.props, double = _a.double, type = _a.type, rangeIdx = _a.rangeIdx, disabledItems = _a.disabledItems, range = _a.range, isOpenPanel = _a.isOpenPanel;
            var value = defaultValue ? defaultValue : new Date();
            var values = parseDate(formatDate(value, _this.datePattern));
            var disabledItemsState = [];
            disabledItems.map(function (item) {
                var cacheValue = inputDateParseDate(item);
                if (cacheValue) {
                    disabledItemsState.push(formatDate(cacheValue, _this.datePattern));
                }
            });
            var rangeState = [];
            range.map(function (item) {
                var rangeValue;
                if (item) {
                    var cacheValue = inputDateParseDate(item);
                    if (cacheValue) {
                        rangeValue = formatDate(cacheValue, _this.datePattern);
                    }
                }
                rangeState.push(rangeValue);
            });
            var data = {
                value: defaultValue ? formatDate(defaultValue, _this.datePattern) : '',
                year: values[0],
                month: values[1],
                day: defaultValue ? values[2] : 0,
                disabledItems: disabledItemsState,
                range: rangeState,
            };
            if (/datetime/.test(type) && defaultValue) {
                var dateValue = inputDateParseDate(defaultValue);
                dateValue &&
                    Object.assign(data, {
                        timeValue: formatTime(dateValue, _this.timePattern),
                    });
            }
            if (double) {
                Object.assign(data, {
                    nextYear: getNextYear(data.month, data.year),
                    nextMonth: getNextMonth(data.month),
                });
            }
            if (rangeIdx && defaultRangeValue) {
                var rangeDateValue = inputDateParseDate(defaultRangeValue);
                rangeDateValue &&
                    Object.assign(data, {
                        rangeDate: formatDate(rangeDateValue, _this.datePattern),
                    });
            }
            if (rangeIdx && isOpenPanel) {
                Object.assign(data, {
                    mouseOver: true,
                });
            }
            return data;
        };
        /**
         * 选择日期处理函数
         * @param year
         * @param month
         * @param day
         * @param endDate
         */
        _this.chooseDay = function (e, date) {
            var value = /datetime/.test(_this.props.type) ? date + " " + _this.state.timeValue : date;
            var valueDate = new Date(value.replace(/\-/g, '/'));
            _this.setState(Object.assign(_this.getParseDate(valueDate, _this.props.defaultRangeValue)), function () {
                if (!_this.props.hasConfirmBtn) {
                    _this.confirm(e);
                }
            });
        };
        /**
         * 确认
         */
        _this.confirm = function (e) {
            var _a = _this.state, value = _a.value, timeValue = _a.timeValue;
            value && _this.props.onChoose(e, value + " " + (/datetime/.test(_this.props.type) ? timeValue : ''));
        };
        /**
         * 鼠标
         * @param e
         */
        _this.handerMouseDown = function (e) {
            if (_this.state.mouseOver) {
                e.preventDefault();
            }
        };
        /**
         * 鼠标划入
         */
        _this.handleMouseEnter = function () {
            _this.setState({
                mouseOver: true,
            });
        };
        /**
         * 鼠标划出
         */
        _this.handleMouseLeave = function () {
            _this.setState({
                mouseOver: false,
            });
        };
        /**
         * 开启选择年面板
         */
        _this.openYearPanel = function () {
            _this.setState({
                isOpenYearsPanel: true,
            });
        };
        /**
         * 更新年
         * @param year
         */
        _this.updateYear = function (year) {
            var month = _this.state.month;
            _this.setState({
                year: year,
                nextYear: getNextYear(month, year),
                isOpenYearsPanel: false,
            });
        };
        /**
         * 开启选择月份面板
         */
        _this.openMonthPanel = function () {
            _this.setState({
                isOpenMonthsPanel: true,
            });
        };
        /**
         * 更新月份
         * @param year
         * @param month
         */
        _this.updateMonth = function (year, month) {
            _this.setState({
                year: year,
                month: month,
                nextYear: getNextYear(month, year),
                nextMonth: getNextMonth(month),
                isOpenMonthsPanel: false,
            });
        };
        /**
         * 上一年
         */
        _this.setPrevYear = function () {
            var _a = _this.state, year = _a.year, nextYear = _a.nextYear;
            _this.setState({
                year: year - 1,
                nextYear: nextYear - 1,
            });
        };
        /**
         * 下一年
         */
        _this.setNextYear = function () {
            var _a = _this.state, year = _a.year, nextYear = _a.nextYear;
            _this.setState({
                year: year + 1,
                nextYear: nextYear + 1,
            });
        };
        /**
         * 上个月
         */
        _this.setPrevMonth = function () {
            var _a = _this.state, month = _a.month, year = _a.year;
            _this.setState({
                year: getPrevYear(month, year),
                month: getPrevMonth(month),
                nextYear: year,
                nextMonth: month,
            });
        };
        /**
         * 下个月
         */
        _this.setNextMonth = function () {
            var _a = _this.state, year = _a.year, month = _a.month;
            var nextYear = getNextYear(month, year);
            var nextMonth = getNextMonth(month);
            _this.setState({
                year: nextYear,
                month: nextMonth,
                nextYear: getNextYear(nextMonth, nextYear),
                nextMonth: getNextMonth(nextMonth),
            });
        };
        /**
         * 渲染时间日期导航
         */
        _this.renderHeader = function () {
            var double = _this.props.double;
            var wrapCls = ['flex', 'items-center', 'h-px-32', 'px-px-12'];
            wrapCls.push(double ? 'w-full' : 'w-px-240');
            var txtCls = [
                'flex-1',
                'flex',
                'h-px-32',
                'mx-px-10',
                'items-center',
                'justify-center',
            ];
            var yearCls = ['cursor-pointer'];
            var monthCls = ['pl-px-8', 'cursor-pointer'];
            var iconCls = ['h-px-32', 'px-px-2', 'py-px-5', 'mx-px-4'];
            var cursor = ['cursor-pointer'];
            var _a = _this.state, year = _a.year, month = _a.month, nextYear = _a.nextYear, nextMonth = _a.nextMonth;
            return (React.createElement(DivTag, { atomics: wrapCls },
                React.createElement(SpanTag, { atomics: iconCls.concat(cursor), onClick: function () { return _this.setPrevYear(); } },
                    React.createElement(ArrowLeftOutlined, null),
                    React.createElement(ArrowLeftOutlined, { className: 'date-picker-header-prevIcon' })),
                React.createElement(SpanTag, { atomics: iconCls.concat(cursor), onClick: function () { return _this.setPrevMonth(); } },
                    React.createElement(ArrowLeftOutlined, null)),
                React.createElement(SpanTag, { atomics: txtCls },
                    React.createElement(SpanTag, { atomics: yearCls.concat(cursor), onClick: _this.openYearPanel },
                        year,
                        "\u5E74"),
                    React.createElement(SpanTag, { atomics: monthCls.concat(cursor), onClick: _this.openMonthPanel },
                        month,
                        "\u6708")),
                double && (React.createElement(SpanTag, { atomics: txtCls.concat(['pl-px-80']) },
                    React.createElement(SpanTag, { atomics: yearCls.concat(cursor), onClick: _this.openYearPanel },
                        nextYear,
                        "\u5E74"),
                    React.createElement(SpanTag, { atomics: monthCls.concat(cursor), onClick: _this.openMonthPanel },
                        nextMonth,
                        "\u6708"))),
                React.createElement(SpanTag, { atomics: iconCls.concat(cursor), onClick: function () { return _this.setNextMonth(); } },
                    React.createElement(ArrowRightOutlined, null)),
                React.createElement(SpanTag, { atomics: iconCls.concat(cursor), onClick: function () { return _this.setNextYear(); } },
                    React.createElement(ArrowRightOutlined, { className: 'date-picker-header-nextIcon' }),
                    React.createElement(ArrowRightOutlined, null))));
        };
        /**
         * 选择今天
         */
        _this.chooseDays = function (e) {
            _this.setState(Object.assign(_this.getParseDate(new Date(), _this.props.defaultRangeValue)), function () {
                _this.confirm(e);
            });
        };
        /**
         * 渲染底部导航
         */
        _this.renderFooter = function () {
            var wrapCls = [
                'h-px-32',
                'flex-1',
                'flex',
                'items-center',
                'justify-center',
                'text-xs',
                'w-full',
                'border-gray-200',
                'border-solid',
                'border-t',
            ];
            var nowCls = ['flex-1', 'text-brand-600', 'px-px-10', 'py-px-3'];
            var nowTxtCls = ['cursor-pointer'];
            var confirmCls = [
                'w-px-64',
                'h-px-24',
                'mx-px-10',
                'cursor-pointer',
                'text-white',
                'rounded-sm',
                'text-center',
                'text-xs',
                'leading-6',
            ];
            if (_this.state.value) {
                confirmCls.push('bg-brand-600');
            }
            else {
                confirmCls.push('bg-gray-200');
            }
            return (React.createElement(DivTag, { atomics: wrapCls },
                _this.props.showToday ? (React.createElement(SpanTag, { atomics: nowCls },
                    React.createElement(SpanTag, { atomics: nowTxtCls, onClick: function (e) { return _this.chooseDays(e); } }, /datetime/.test(_this.props.type) ? '此刻' : '今天'))) : (React.createElement(SpanTag, { atomics: nowCls })),
                React.createElement(SpanTag, { atomics: nowCls }),
                React.createElement(SpanTag, { atomics: confirmCls, onClick: function (e) { return _this.confirm(e); } }, "\u786E\u5B9A")));
        };
        /**
         * 选择时间
         * @param e
         * @param selected
         * @param type
         */
        _this.onSelectTime = function (e, selected, type) {
            if (type === void 0) { type = 'custom'; }
            _this.setState({
                timeValue: selected,
            });
        };
        var _a = _this.props, formatValue = _a.formatValue, defaultRangeValue = _a.defaultRangeValue;
        var parseDateData = _this.getParseDate(formatValue, defaultRangeValue);
        _this.state = Object.assign({
            mouseOver: false,
            isOpenYearsPanel: false,
            isOpenMonthsPanel: false,
            nextYear: 0,
            nextMonth: 0,
            nextDay: 0,
            day: 0,
            value: '',
            timeValue: '00:00:00',
            rangeDate: '',
        }, parseDateData);
        return _this;
    }
    Calendar.prototype.componentDidMount = function () {
        document.addEventListener('mousedown', this.handerMouseDown);
    };
    Calendar.prototype.componentWillUnmount = function () {
        document.removeEventListener('mousedown', this.handerMouseDown);
    };
    Calendar.prototype.render = function () {
        var _this = this;
        var _a = this.props, double = _a.double, type = _a.type, hasConfirmBtn = _a.hasConfirmBtn, rangeIdx = _a.rangeIdx, range = _a.range;
        var _b = this.state, isOpenMonthsPanel = _b.isOpenMonthsPanel, isOpenYearsPanel = _b.isOpenYearsPanel, timeValue = _b.timeValue, year = _b.year, month = _b.month, reset = __rest(_b, ["isOpenMonthsPanel", "isOpenYearsPanel", "timeValue", "year", "month"]);
        var contextCls = [
            'absolute',
            'shadow-lg',
            'rounded',
            'left-0',
            'bg-white',
            'z-50',
            'border',
            'border-solid',
            'border-gray-100',
        ];
        (isOpenYearsPanel || isOpenMonthsPanel) && contextCls.push('w-px-240');
        var timeWrapCls = ['relative', 'w-px-120'];
        var timeHeaderCls = ['h-px-32', 'flex', 'items-center', 'justify-center'];
        var timeContentCls = [
            'h-px-262',
            'border-gray-200',
            'border-solid',
            'border',
            'border-r-0',
            'border-b-0',
        ];
        return (React.createElement(DivTag, { name: Calendar.NAME, atomics: contextCls, className: isOpenYearsPanel || isOpenMonthsPanel ? 'date-picker-overflow' : '', onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave },
            React.createElement(DivTag, { atomics: ['inline-flex'] },
                React.createElement(DivTag, { atomics: ['relative'] },
                    this.renderHeader(),
                    React.createElement(DateDayPicker, __assign({ year: year, month: month }, reset, { type: type, rangeIdx: rangeIdx, double: double, chooseDay: this.chooseDay }))),
                /datetime/.test(type) && (React.createElement(DivTag, { atomics: timeWrapCls },
                    React.createElement(DivTag, { atomics: timeHeaderCls }, timeValue),
                    React.createElement(DivTag, { atomics: timeContentCls.concat(timeWrapCls) },
                        React.createElement(TimeComboBox, { value: timeValue, format: this.timePattern, showNow: false, panel: 'dateTime', onChange: function (e, next, type) { return _this.onSelectTime(e, next, type); } }))))),
            hasConfirmBtn && this.renderFooter(),
            isOpenYearsPanel && (React.createElement(DateYearPicker, { year: year, updateYear: this.updateYear })),
            isOpenMonthsPanel && (React.createElement(DateMonthPicker, { year: year, month: month, updateMonth: this.updateMonth }))));
    };
    Calendar.defaultProps = defaultProps;
    Calendar.NAME = 'calendar';
    Calendar.displayName = 'Calendar';
    return Calendar;
}(Component));
export { Calendar };
